export default function ProgramRoadmap() {
  const steps = [
    { title: 'Диагностика', desc: 'Аудит текущих продаж: прослушивание звонков, анализ CRM, интервью с сотрудниками' },
    { title: 'Адаптация программы', desc: 'Разработка индивидуальной программы под ваш продукт, рынок и цикл сделки' },
    { title: 'Корпоративный тренинг', desc: 'Интенсивное обучение с практикой на реальных сделках компании' },
    { title: 'Практика', desc: 'Отработка навыков: переговоры, встречи, работа с ЛПР, защита цены' },
    { title: 'Разбор звонков', desc: 'Детальный анализ записей переговоров участников с обратной связью' },
    { title: 'Разбор встреч', desc: 'Анализ реальных B2B-встреч: подготовка, стратегия, аргументация' },
    { title: 'Сопровождение', desc: 'Посттренинговое сопровождение: аудит, поддержка в Telegram, корректировка' },
    { title: 'Рост KPI', desc: 'Измеримый рост: конверсия, средний чек, маржа, скорость сделки' },
  ];

  return (
    <section id="program" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-road-map-line"></i>
            Roadmap
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Что входит в программу
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системный подход: от диагностики текущей ситуации до измеримого роста ключевых показателей.
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[23px] top-4 bottom-4 w-0.5 bg-teal-200 hidden md:block"></div>

          <div className="space-y-0">
            {steps.map((item, i) => (
              <div key={i} className="relative flex items-start gap-6 pb-8 last:pb-0">
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-sm">{i + 1}</span>
                  </div>
                </div>
                <div className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 flex-1 hover:border-teal-100 transition-colors">
                  <h3 className="text-lg font-bold text-gray-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
                {i < steps.length - 1 && (
                  <div className="hidden md:flex absolute left-[17px] top-14 items-center justify-center z-10">
                    <i className="ri-arrow-down-line text-teal-400 text-lg"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}